

define(['squid/index', './directive', './addbank/route', './sepa/route'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-add-bank.route', ['squid', 'xo-add-bank.directive', 'xo-add-bank.addbank.route', 'xo-add-bank.sepa.route']).factory('$AddBankFlowRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('BankRoute', {
            name: 'bank',
            directive: 'xo-add-bank-flow',
            titleContent: 'asideHeader.addBank',
            children: [{
                name: '$XOAddBankRoute',
                attributes: {
                    token: 'token',
                    'parent-callbacks': 'callbacks',
                    'error-message': 'errorMessage',
                    bank: 'bank',
                    sidebar: 'sidebar',
                    hideparenthead: 'hideparenthead',
                    'page-level': 'pageLevel'
                }
            }, {
                name: '$XOSepaRoute',
                attributes: {
                    token: 'token',
                    'parent-callbacks': 'callbacks',
                    model: 'bank',
                    sidebar: 'sidebar',
                    hideparenthead: 'hideparenthead'
                }
            }]
        });
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-wallet-components/src/add-bank/route.js
 ** module id = 249
 ** module chunks = 1
 **/